"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ipDrugEntryCancelRequestSchema = void 0;
const zod_1 = require("zod");
const financial_correction_stage_response_1 = require("./financial-correction-stage.response");
const financial_payment_correction_request_1 = require("../request/financial-payment-correction.request");
/**
 * ONE IP DRUG BILL CANCEL REQUEST, as the verifier and approver read it. The bill's facts are SNAPSHOTS from the moment the request was made;
 * `effects` is what approving would do TODAY (or why it can no longer be applied), computed fresh for a PENDING request.
 */
exports.ipDrugEntryCancelRequestSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    status: financial_payment_correction_request_1.paymentCorrectionStatusEnum,
    entryId: zod_1.z.string().uuid(),
    ipAdmissionId: zod_1.z.string().uuid(),
    drugBillNumber: zod_1.z.string(),
    /** The IP bill number the drug bill sits on. */
    billNumber: zod_1.z.string().nullable(),
    patientName: zod_1.z.string(),
    uhid: zod_1.z.string().nullable(),
    billDate: zod_1.z.string(),
    /** Integer paise. `remainingAmount` is what cancelling reverses (the bill minus any earlier refund). */
    amount: zod_1.z.number().int(),
    remainingAmount: zod_1.z.number().int(),
    reason: zod_1.z.string(),
    requestedBy: zod_1.z.string().uuid().nullable(),
    requestedByName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    /** Where the request is in Request -> Verify -> Approve. See `correctionStageEnum`. */
    stage: financial_correction_stage_response_1.correctionStageEnum,
    verifiedBy: zod_1.z.string().uuid().nullable(),
    verifiedByName: zod_1.z.string().nullable(),
    verifiedAt: zod_1.z.string().nullable(),
    verificationNote: zod_1.z.string().nullable(),
    approvedBy: zod_1.z.string().uuid().nullable(),
    approvedByName: zod_1.z.string().nullable(),
    approvedAt: zod_1.z.string().nullable(),
    decisionReason: zod_1.z.string().nullable(),
    appliedSummary: zod_1.z.array(zod_1.z.string()).nullable(),
    effects: zod_1.z.array(zod_1.z.string()).nullable().optional(),
});
//# sourceMappingURL=financial-ip-drug-cancel.response.js.map